<script setup>

import { defineProps, defineEmits } from 'vue'

defineProps({
    loading: Boolean,
    disabled: Boolean,
    outlined: Boolean,
    block: Boolean,
    color: String,
    text: String,
    icon: String,
});

const emit = defineEmits(["press"]);

function press() {
    emit("press");
}

</script>

<template>
    <div>
        <v-btn
            depressed
            small
            :color="color"
            :outlined="outlined"
            :block="block"
            :class="color ? 'ml-2 white--text' : 'ml-2'"
            :loading="loading"
            :disabled="disabled"
            @click="press"
        >
            {{ text }}
            <v-icon right>{{ icon }}</v-icon>
        </v-btn>
    </div>
</template>